import { validatePIS } from 'utils/validation/validators'

type ValidatePISOnCustomFormParams = {
  pis: string
  isRequired?: boolean
}

export default function validatePISOnCustomForm({ pis, isRequired }: ValidatePISOnCustomFormParams) {
  let error = ''
  if (isRequired && !pis) {
    error = 'Este campo é obrigatório'
  }
  if (pis && !validatePIS(pis)) {
    error = 'Este PIS está incorreto.'
  }
  return error
}
